module.exports = __webpack_public_path__ + "ag.8bd07b26.svg";